import type { Template } from "@/types";

export const LA_07_H3_V4: Template[] = [
    {
        id: "la-07-h3v4-01",
        name: "LA 01 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 108, y: 210, width: 461, height: 285, rotation: 0, imageRotation: 0 },
            { id: "2", x: 108, y: 46, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 46, width: 227, height: 156, rotation: 0, imageRotation: 0 },
            { id: "4", x: 843, y: 46, width: 168, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 843, y: 275, width: 168, height: 220, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 46, width: 167, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 275, width: 167, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-02",
        name: "LA 02 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 79, y: 46, width: 198, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 198, width: 198, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 79, y: 350, width: 198, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 285, y: 46, width: 304, height: 448, rotation: 0, imageRotation: 0 },
            { id: "5", x: 782, y: 46, width: 302, height: 448, rotation: 0, imageRotation: 0 },         
            { id: "6", x: 1091, y: 46, width: 146, height: 220, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1091, y: 274, width: 146, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-03",
        name: "LA 03 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 110, y: 47, width: 454, height: 288, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 110, y: 342, width: 224, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 342, width: 223, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 45, width: 299, height: 453, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1111, y: 45, width: 113, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1111, y: 199, width: 113, height: 146, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1111, y: 353, width: 113, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-04",
        name: "LA 04 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 47, y: 65, width: 181, height: 132, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 205, width: 181, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 47, y: 345, width: 181, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 236, y: 65, width: 252, height: 411, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 65, width: 134, height: 202, rotation: 0, imageRotation: 0 },
            { id: "6", x: 495, y: 275, width: 134, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 855, y: 41, width: 317, height: 459, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h3v4-05",
        name: "LA 05 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 226, y: 43, width: 224, height: 148, rotation: 0, imageRotation: 0 },
            { id: "2", x: 226, y: 199, width: 224, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 226, y: 354, width: 224, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 856, y: 43, width: 155, height: 225, rotation: 0, imageRotation: 0 },
            { id: "5", x: 856, y: 276, width: 155, height: 225, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 43, width: 155, height: 225, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 276, width: 155, height: 225, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-06",
        name: "LA 06 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_06.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 58, y: 45, width: 304, height: 208, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 58, y: 261, width: 148, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 214, y: 261, width: 148, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 370, y: 45, width: 303, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 370, y: 261, width: 147, height: 236, rotation: 0, imageRotation: 0 },
            { id: "6", x: 525, y: 261, width: 147, height: 236, rotation: 0, imageRotation: 0 },
            { id: "7", x: 680, y: 45, width: 613, height: 453, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-07",
        name: "LA 07 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 59, width: 285, height: 421, rotation: 0, imageRotation: 0 },
            { id: "2", x: 292, y: 59, width: 283, height: 421, rotation: 0, imageRotation: 0 },
            { id: "3", x: 583, y: 59, width: 285, height: 421, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 875, y: 59, width: 187, height: 135, rotation: 0, imageRotation: 0 },
            { id: "5", x: 875, y: 202, width: 187, height: 135, rotation: 0, imageRotation: 0 },
            { id: "6", x: 875, y: 345, width: 187, height: 135, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 59, width: 283, height: 421, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-08",
        name: "LA 08 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 59, y: 45, width: 613, height: 453, rotation: 0, imageRotation: 0 },
            { id: "2", x: 680, y: 45, width: 304, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 991, y: 45, width: 303, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 261, width: 148, height: 236, rotation: 0, imageRotation: 0 },
            { id: "5", x: 835, y: 261, width: 148, height: 236, rotation: 0, imageRotation: 0 },
            { id: "6", x: 991, y: 261, width: 148, height: 236, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1146, y: 261, width: 148, height: 236, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h3v4-09",
        name: "LA 09 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 46, width: 280, height: 448, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 46, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 198, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 288, y: 350, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 498, y: 46, width: 280, height: 448, rotation: 0, imageRotation: 0 },
            { id: "6", x: 785, y: 46, width: 279, height: 448, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1072, y: 46, width: 279, height: 448, rotation: 0, imageRotation: 0 }           
        ],
    },

    {
        id: "la-07-h3v4-10",
        name: "LA 10 - H3V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h3_v4_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 46, width: 280, height: 448, rotation: 0, imageRotation: 0 },
            { id: "2", x: 288, y: 46, width: 279, height: 448, rotation: 0, imageRotation: 0 },
            { id: "3", x: 575, y: 46, width: 279, height: 448, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 46, width: 279, height: 448, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1149, y: 46, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1149, y: 199, width: 203, height: 143, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1149, y: 351, width: 203, height: 143, rotation: 0, imageRotation: 0 }
        ],
    }
];